import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';

@Service()
export class HttpService {
    private httpClient = inject(HttpClient);

    getQrCode(url: string): Observable<string> {
        return this.httpClient.get(url, { responseType: 'text' });
    }
}
